import React from 'react';
import styles from '../CallConnectionScreen.module.scss';
import PropTypes from 'prop-types';
import { useLanguage } from '@/localization/useLanguage';
import { useOutgoingCall } from '@/features/calls/viewmodels/useOutgoingCall';
import { IconAudioMute, IconDeclineCallIcon, IconMic, IconVideoMute, IconVideo } from '@/assets/images';
import { CALLKIT_CALLSTATUS } from '@/features/calls/constants';

/**
 * Pure rendering component — no SDK imports.
 * endCall comes from useOutgoingCall() viewmodel.
 */
export const OutgoingCallScreen = ({ isAudioMuted, isVideoMuted, callStatus }) => {
   const { t } = useLanguage();
   const { handleEndCall, handleToggleAudio } = useOutgoingCall(isAudioMuted, isVideoMuted);
   const isRinging = callStatus?.toUpperCase() === CALLKIT_CALLSTATUS.RINGING;

   return (
      <div className={`ct-flex ct-gap16  ${styles.controlButtonWrapper}`}>
         <button
            className={`ct-flex ct-aiCenter ct-jcCenter  ${styles.controlButton}`}
            aria-label={isAudioMuted ? t('common.UNMUTE') : t('common.MUTE')}
            onClick={handleToggleAudio}
            disabled={!isRinging}
         >
            {isAudioMuted ? (
               <i className="ct-icon">
                  <IconAudioMute />
               </i>
            ) : (
               <i className="ct-icon">
                  <IconMic />
               </i>
            )}
         </button>
         <button
            className={`ct-flex ct-aiCenter ct-jcCenter  ${styles.controlButton}`}
            aria-label={!isVideoMuted ? t('common.TURN_VIDEO_OFF') : t('common.TURN_VIDEO_ON')}
            disabled={true}
         >
            {isVideoMuted ? (
               <i className="ct-icon">
                  <IconVideoMute />
               </i>
            ) : (
               <i className="ct-icon">
                  <IconVideo />
               </i>
            )}
         </button>
         <button
            className={`ct-flex ct-aiCenter ct-jcCenter  ${styles.controlButton} ${styles.red}`}
            onClick={handleEndCall}
            aria-label={t('common.END_CALL')}
         >
            <i className="ct-icon">
               <IconDeclineCallIcon />
            </i>
         </button>
      </div>
   );
};

OutgoingCallScreen.propTypes = {
   isAudioMuted: PropTypes.bool.isRequired,
   isVideoMuted: PropTypes.bool.isRequired,
   callStatus: PropTypes.string,
};
